import { render, staticRenderFns } from "./pay-rank.vue?vue&type=template&id=224417dd&scoped=true&"
import script from "./pay-rank.vue?vue&type=script&lang=js&"
export * from "./pay-rank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224417dd",
  null
  
)

export default component.exports